"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUpdateWarehouseStatusRequest = void 0;
const superstruct_1 = require("superstruct");
const isStruct_1 = require("../utils/isStruct");
const UpdateWarehouseStatusRequestStruct = (0, superstruct_1.object)({
    warehouseId: (0, superstruct_1.string)(),
    status: (0, superstruct_1.string)(),
    reason: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
function isUpdateWarehouseStatusRequest(obj) {
    return (0, isStruct_1.isStruct)(obj, UpdateWarehouseStatusRequestStruct, "UpdateWarehouseStatusRequest");
}
exports.isUpdateWarehouseStatusRequest = isUpdateWarehouseStatusRequest;
//# sourceMappingURL=UpdateWarehouseStatusRequest.js.map